import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";

import useScreenMobile from "hooks/useScreen";

import hide from "assets/images/createPassword/hide.svg";
import show from "assets/images/createPassword/show.svg";
import darkShow from "assets/images/createPassword/darkShow.svg";
import darkHide from "assets/images/createPassword/darkHide.svg";
import "./signIn.scss";
import Button from "components/Button/index";
import useTheme from "hooks/observer";
import { signInContext } from "context/SigninContext";

const SignIn = ({ nextStep }) => {
  const theme = useTheme();
  const hideImage = theme === "light" ? hide : darkShow;
  const showImage = theme === "light" ? show : darkHide;
  // const navigate = useNavigate();
  const isSmallDeskTop = useScreenMobile({ size: 1370 });
  const isMobile = useScreenMobile({ size: 568 });

  // const [isTypeSelect, setIsTypeSelect] = useState("individual");
  const [showPassword, setShowPassword] = useState(false);
  const { formData, setFormData, isTypeSelect, setIsTypeSelect, addPinSelect, setAddPinSelect } =
    useContext(signInContext);
  // const [formData, setFormData] = useState({
  //   individualEmail: "",
  //   individualPassword: "",
  //   orgName: "",
  //   orgEmail: "",
  //   orgPassword: ""
  // });
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    // console.log("in sign in use effect");
    // Ensure isTypeSelect is set to "individual" to show form fields
    setIsTypeSelect("individual");
    setFormData({
      individualEmail: "",
      individualPassword: "",
      orgName: "",
      orgEmail: "",
      orgPassword: ""
    });
    setErrors({});
  }, []);

  // const handleSwitch = (e) => {
  //   const id = e.target.getAttribute("id");
  //   setIsTypeSelect(id);
  //   setShowPassword(false);

  //   if (id === "individual") {
  //     setFormData({
  //       individualEmail: "",
  //       individualPassword: ""
  //     });
  //   } else {
  //     setFormData({
  //       individualEmail: "",
  //       individualPassword: ""
  //     });
  //   }

  //   setErrors({});
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validate(name, value);
  };

  const validate = (fieldName, value) => {
    let error = "";
    // const nameRegex = /^[a-zA-Z]{2,30}$/;

    if (isTypeSelect === "individual") {
      if (fieldName === "individualEmail") {
        if (!value) {
          error = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = "Please enter the valid email id";
        }
      }
      if (fieldName === "individualPassword") {
        if (!value) {
          error = "Password is required";
        } else if (value.length < 12) {
          error = "Password must be at least 12 characters";
        }
      }
    }

    if (isTypeSelect === "org") {
      if (fieldName === "individualEmail") {
        if (!value) {
          error = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = "Please enter the valid email id";
        }
      }
      if (fieldName === "individualPassword") {
        if (!value) {
          error = "Password is required";
        } else if (value.length < 12) {
          error = "Password must be at least 12 characters";
        }
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: error
    }));
  };


  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const password = formData.individualPassword.trim();
      if (!password) {
        setErrors((prev) => ({
          ...prev,
          individualPassword: "Password is required"
        }));
        return;
      } else if (password.length < 12) {
        setErrors((prev) => ({
          ...prev,
          individualPassword: "Password must be at least 12 characters"
        }));
        return;
      }
      handleSubmit(e);
    }

    // if(isTypeSelect==="org" && e.target.name==="orgName"){
    //   const isNumber= /[0-9]/.test(e.key);
    //   if(isNumber){
    //     e.preventDefault();
    //   }
    // }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!Object.values(errors).some((error) => error)) {
      // const successSigninMsg = true;
      // navigate("/verifyotp", { state: successSigninMsg });

      // if (isTypeSelect === "individual") {
      //   setFormData({ individualEmail: "", individualPassword: "" });
      // } else {
      //   setFormData({
      //     orgName: "",
      //     orgEmail: "",
      //     orgPassword: ""
      //   });
      // }
      nextStep();
    } else {
      setFormData({
        individualEmail: "",
        individualPassword: "",
        orgName: "",
        orgEmail: "",
        orgPassword: ""
      });
      setErrors({});
      alert("Please fix the errors before submitting.");
    }
  };

  const checkFormValidity = () => {
    const relevantFields =
      isTypeSelect === "individual"
        ? {
          individualEmail: formData.individualEmail,
          individualPassword: formData.individualPassword
        }
        : {
          individualEmail: formData.individualEmail,
          individualPassword: formData.individualPassword
        };

    const allFieldsFilled = Object.values(relevantFields).every(
      (value) => value?.trim() !== ""
    );

    const relevantErrors =
      isTypeSelect === "individual"
        ? {
          individualEmail: errors.individualEmail,
          individualPassword: errors.individualPassword
        }
        : {
          individualEmail: errors.individualEmail,
          individualPassword: errors.individualPassword
        };

    const hasNoErrors = Object.values(relevantErrors).every((error) => !error);

    return allFieldsFilled && hasNoErrors;
  };

  useEffect(() => {
    setIsFormValid(checkFormValidity());
  }, [formData, errors, isTypeSelect, addPinSelect, setAddPinSelect]);


  // if (isMobile) {
  //   return (
  //     <section className="signIn">
  //       <div className="container signInContainer">
  //         <div className="titleSection">
  //           <h1 className="title">Sign In</h1>
  //         </div>
  //         <div className="contentSection">
  //           <div className="signInData">
  //             <div className="signInDataContents">
  //               <p style={{ textAlign: "center", color: "#888", fontSize: "1.2rem" }}>
  //                   <b>Thank you for choosing Ysafe.io.</b> <br />
  //                   Our platform is currently optimized for desktop and laptop devices.<br />
  //                   Please access it from a computer for the best experience.<br />
  //                   <b>Mobile applications will be available soon!</b>
  //               </p>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </section>
  //   );
  // }

  return (
    <>
      <section
        className={`signIn ${isSmallDeskTop && isTypeSelect === "org" && !isMobile ? "signInHeight" : ""}`}
      >
        <div className="container signInContainer">
          <div className="titleSection">
            <h1 className="title">Sign In</h1>
            {/* <p className="content">
              Log in to the secure storage provider for seamless access and
              trusted data management.
            </p> */}
          </div>
          <div className="contentSection">
            {/* <div className="signInType" onClick={handleSwitch}>
              <p
                className={`type ${isTypeSelect === "individual" ? "active" : "active"}`}
                id="individual"
              >
                Individual
              </p>
              {/* <p
                className={`type ${isTypeSelect === "org" ? "inActive" : "inActive"}`}
                id="org"
              >
                Organisation
              </p> 
            </div> */}
            <div className="signInData">
              <div className="signInDataContents">
                <form className="form" onSubmit={handleSubmit}>
                  <div className="formData">
                    {isTypeSelect === "individual" && (
                      <>
                        <div className="field">
                          <label htmlFor="individualEmail">Email</label>
                          <input
                            type="email"
                            name="individualEmail"
                            id="individualEmail"
                            placeholder="you@company.com"
                            value={formData.individualEmail}
                            maxLength={125}
                            onChange={handleChange}
                            className={errors.individualEmail && "errorBorder"}
                          />
                          {errors.individualEmail && (
                            <p className="errorMsg">{errors.individualEmail}</p>
                          )}
                        </div>
                        <div className="field pwd">
                          <label htmlFor="individualPassword">Password</label>
                          <div
                            className={`passwordContainer ${errors.individualPassword ? "errorBorder" : ""} `}
                          >
                            <input
                              type={showPassword ? "text" : "password"}
                              name="individualPassword"
                              id="individualPassword"
                              placeholder="Enter the password"
                              value={formData.individualPassword}
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                              maxLength={80}
                            />
                            <div
                              className="imageWrapper"
                              onClick={() => {
                                setShowPassword(!showPassword);
                              }}
                            >
                              <img
                                style={{ cursor: "pointer" }}
                                src={showPassword ? showImage : hideImage}
                                alt="Show password"
                              />
                            </div>
                          </div>

                          {errors.individualPassword && (
                            <p className="errorMsg">
                              {errors.individualPassword}
                            </p>
                          )}
                        </div>
                      </>
                    )}
                    {/* isTypeSelect === "org" && (
                      <>
                        <div className="field">
                          <label htmlFor="orgName">Organisation Name</label>
                          <input
                            type="text"
                            name="orgName"
                            id="orgName"
                            placeholder="Eg : Google Inc"
                            maxLength={51}
                            value={formData.orgName}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            className={errors.orgName ? "errorBorder" : ""}
                          />
                          {errors.orgName && (
                            <p className="errorMsg">{errors.orgName}</p>
                          )}
                        </div>
                        <div className="field">
                          <label htmlFor="orgEmail">Organisation Email</label>
                          <input
                            type="email"
                            name="orgEmail"
                            id="orgEmail"
                            placeholder="you@company.com"
                            value={formData.orgEmail}
                            onChange={handleChange}
                            className={errors.orgEmail ? "errorBorder" : ""}
                          />
                          {errors.orgEmail && (
                            <p className="errorMsg">{errors.orgEmail}</p>
                          )}
                        </div>
                        <div className="field pwd">
                          <label htmlFor="email">Password</label>
                          <div
                            className={`passwordContainer ${errors.orgPassword ? "errorBorder" : ""}`}
                          >
                            <input
                              type={showPassword ? "text" : "password"}
                              name="orgPassword"
                              id="email"
                              placeholder="Enter the password"
                              value={formData.orgPassword}
                              onChange={handleChange}
                            />
                            <div
                              className="imageWrapper"
                              onClick={() => {
                                setShowPassword(!showPassword);
                              }}
                            >
                              <img
                                style={{ cursor: "pointer" }}
                                src={showPassword ? showImage : hideImage}
                                alt="Show password"
                              />
                            </div>
                          </div>

                          {errors.orgPassword && (
                            <p className="errorMsg">{errors.orgPassword}</p>
                          )}
                        </div>
                      </>
                    ) */}
                  </div>
                  {/* <div className="rememberMe">
                    <input
                      type="checkbox"
                      name="rememberMe"
                      id="rememberMe"
                      checked={addPinSelect}
                      onChange={(e) => setAddPinSelect(e.target.checked)}
                      className="rememberMeCheckbox"
                    />
                    <label htmlFor="rememberMe" className="rememberMeText">
                      Remember Me on This System
                    </label>
                  </div> */}
                  <div className="startButtonContainer">
                    {/* <button
                      type="submit"
                      className={`startButton ${isFormValid ? "enabled" : "disabled"}`}
                      disabled={!isFormValid}
                    >
                      Sign In
                    </button> */}
                    <Button
                      title="Sign In"
                      disabled={!isFormValid}
                      btnType="submit"
                      type="violet"
                    />
                  </div>
                </form>
              </div>
              <div className="signInField">
                <p className="forgotPasswordText">
                  <Link
                    to="/forgotpassword"
                    style={{
                      color: "var(--text-highlight)",
                      textDecoration: "none"
                    }}
                  >
                    Forgot Password?
                  </Link>
                </p>
                <p className="signInContent">
                  Don’t have an account?{" "}
                  <span className="colorText">
                    <Link
                      to="/signup"
                      style={{
                        color: "var(--text-highlight)",
                        textDecoration: "none"
                      }}
                    >
                      Sign Up.
                    </Link>
                  </span>
                </p>
                <div className="rememberMe">
                  <input
                    type="checkbox"
                    name="rememberMe"
                    id="rememberMe"
                    checked={addPinSelect}
                    onChange={(e) => setAddPinSelect(e.target.checked)}
                    className="rememberMeCheckbox"
                  />
                  <label htmlFor="rememberMe" className="rememberMeText">
                    Remember Me on This System
                  </label>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignIn;
